import { useMemo } from 'react';

import { sha256 } from 'js-sha256';

export const useSessionId = ({
	userId,
	cloudId,
	source,
}: {
	userId: string;
	cloudId: string;
	source: string;
}): string => {
	return useMemo(
		() => sha256(`${userId}-${cloudId}-${Date.now().toString()}-${source}`),
		[userId, cloudId, source],
	);
};
